import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import OldDataOverviewContainer from "./OldDataOverviewContainer";

class OldDataContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            activeView: null,
            editRow: null,
            companies: [],
        };

        this.translate = this.props.baseData.translate;

        this.requestCompaniesForUser = this.requestCompaniesForUser.bind(this);
        this.changeView = this.changeView.bind(this);

    }

    componentWillMount() {

        this.requestCompaniesForUser();

    }

    requestCompaniesForUser() {

        const params = {
            action: 'getCompaniesForUser',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.baseData.companies.currentCompany.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    companies: res
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    changeView(activeView = null, editRow = null) {

        this.setState({
            activeView,
            editRow
        });

    }

    render() {

        return (
            <div>
                <OldDataOverviewContainer
                    baseData={this.props.baseData}
                />
            </div>
        );

    }

}

export default OldDataContainer;